const BACK_ACTION = 'back'
const NEXT_ACTION = 'next'
const PREV_ACTION = 'prev'

export const ACTIONS = {
  BACK_ACTION,
  NEXT_ACTION,
  PREV_ACTION
}

export const ACTIONS_TRACKING_DATA = {
  [BACK_ACTION]: {
    event: 'Back To List Clicked'
  },
  [NEXT_ACTION]: {
    event: 'Forward Navigation Clicked'
  },
  [PREV_ACTION]: {
    event: 'Back Navigation Clicked'
  }
}
